import axiosInstance from 'utils/axiosInstance';
import { UserFormValues } from '../UserForm';

export const usersApi = {
  /**
   * Get users based on role and org
   */
  async getUsers(role: string | null, orgId?: string): Promise<any[]> {
    try {
      let url = '';

      if (role === 'ROLE_SUPER_ADMIN') {
        url = orgId
          ? `api/users/org/${orgId}` // filtered by org
          : `api/users/all`; // all users
      } else {
        const orgUid = localStorage.getItem('org_uid');
        url = `api/users/org/${orgUid}`; // normal users
      }

      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching users', error);
      throw error;
    }
  },
  /**
   * Delete user by UID
   */
  async deleteUser(userUid: string): Promise<void> {
    try {
      await axiosInstance.delete(`api/users/${userUid}`);
    } catch (error) {
      console.error('Error deleting user', error);
      throw error;
    }
  },
  /**
   * Update user by UID
   */
  async updateUser(userUid: string, payload: UserFormValues): Promise<any> {
    try {
      const response = await axiosInstance.put(`api/users/${userUid}`, payload);
      return response.data;
    } catch (error) {
      console.error('Error updating user', error);
      throw error;
    }
  },
  /**
   * Create / Register user
   */
  async createUser(payload: UserFormValues): Promise<any> {
    try {
      const response = await axiosInstance.post('api/auth/register', payload);
      return response.data;
    } catch (error) {
      console.error('Error creating user', error);
      throw error;
    }
  },
  /**
   * Reset password for logged-in user (token extracted from JWT on backend)
   */
  async resetPassword(payload: { currentPassword: string; newPassword: string }): Promise<any> {
    try {
      const response = await axiosInstance.put('api/auth/reset-password', payload);
      return response.data;
    } catch (error) {
      console.error('Error resetting password', error);
      throw error;
    }
  }
};
